import React, { useEffect, useState } from 'react';
import { getCreatorFeedback, exportCreatorFeedback } from '../../api/creator_feedback';
import CreatorFeedbackResults from './CreatorFeedbackResults';
import './CreatorFeedback.scss';

const initialFilters = { brand: '', csm: '', strategy: '', from: '', to: '', category: '', scope: '', status: '' };
const choices = {
  category: [['brand_content_fit', 'Content or style mismatch'], ['audience_fit', 'Audience mismatch'], ['performance', 'Insufficient performance'], ['existing_relationship', 'Existing relationship or outreach'], ['timing', 'Not right now'], ['other', 'Other']],
  scope: [['batch', 'This batch only'], ['strategy', 'Future strategy recommendations'], ['brand', 'Brand exclusion']],
  status: [['removed', 'Removed'], ['restored', 'Restored'], ['withdrawn', 'Feedback withdrawn']]
};

const CreatorFeedback = () => {
  const [draft, setDraft] = useState(initialFilters);
  const [filters, setFilters] = useState(initialFilters);
  const [page, setPage] = useState(1);
  const [result, setResult] = useState({ rows: [], total: 0, pageSize: 50 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [exporting, setExporting] = useState(false);
  const [refresh, setRefresh] = useState(0);
  useEffect(() => {
    let active = true;
    setLoading(true);
    setError('');
    getCreatorFeedback({ ...filters, page }).then(data => { if (active) setResult(data); })
      .catch(() => { if (active) setError('Could not load creator feedback. Please retry.'); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [filters, page, refresh]);
  const update = (key, value) => setDraft(current => ({ ...current, [key]: value }));
  const apply = event => { event.preventDefault(); setFilters({ ...draft }); setPage(1); };
  const clear = () => { setDraft(initialFilters); setFilters(initialFilters); setPage(1); };
  const download = async () => {
    setExporting(true);
    setError('');
    try { await exportCreatorFeedback(filters); }
    catch { setError('Could not export feedback. Retry, or narrow the filters to 10,000 records or fewer.'); }
    finally { setExporting(false); }
  };
  return <div className='creator-feedback'>
    <header><div><h1>Creator feedback</h1><p>Review CSM removals across brands and strategies, including completed and cancelled batches.</p></div><button onClick={download} disabled={loading || exporting || !result.total}>{exporting ? 'Exporting…' : 'Export filtered CSV'}</button></header>
    <form onSubmit={apply} className='creator-feedback-filters'>
      {[['brand', 'Brand'], ['csm', 'CSM'], ['strategy', 'Strategy']].map(([key, label]) => <label key={key}>{label}<input value={draft[key]} maxLength={200} placeholder={`Search ${label.toLowerCase()} name`} onChange={event => update(key, event.target.value)} /></label>)}
      {[['from', 'From (UTC)'], ['to', 'Through (UTC)']].map(([key, label]) => <label key={key}>{label}<input type='date' value={draft[key]} onChange={event => update(key, event.target.value)} /></label>)}
      {Object.entries(choices).map(([key, options]) => <label key={key}>{key === 'category' ? 'Reason' : key === 'scope' ? 'Scope' : 'Status'}<select value={draft[key]} onChange={event => update(key, event.target.value)}><option value=''>All</option>{options.map(([value, label]) => <option key={value} value={value}>{label}</option>)}</select></label>)}
      <button type='submit'>Apply filters</button><button type='button' onClick={clear}>Clear</button>
    </form>
    {error && <p role='alert'>{error} <button onClick={() => setRefresh(value => value + 1)}>Retry</button></p>}
    {loading ? <p role='status'>Loading feedback…</p> : !error && <><p>{result.total.toLocaleString()} feedback {result.total === 1 ? 'record' : 'records'}</p><CreatorFeedbackResults rows={result.rows} /><footer><button disabled={page === 1} onClick={() => setPage(value => value - 1)}>Previous</button><span>Page {page} of {Math.max(1, Math.ceil(result.total / result.pageSize))}</span><button disabled={page * result.pageSize >= result.total} onClick={() => setPage(value => value + 1)}>Next</button></footer></>}
  </div>;
};
export default CreatorFeedback;
